import React, {useState } from 'react'
import * as S from './DevLoginStyle'

import Title from '../../components/Title'
import Label, { iLabel } from '../../components/Label/Label'
import Input, { iInput } from '../../components/Inputs/Input/Input'
import Button, { iButton } from '../../components/Button'

import UserContext from '../../hooks/UserContext'
import {maskCpf, unMaskCpf} from '../../utils/formatValues'

const Login: React.FC = () => {
    const { onLoginHandler, error} = UserContext()
    const [formLogin, setFormLogin] = useState({sellerCode: '', cpf: '', password: ''})    

    const handleSellerCode = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormLogin(prevState=> ({...prevState, sellerCode: e.target.value.trim()}))
    }

    const handleCpf = (e: React.ChangeEvent<HTMLInputElement>) => {
        const valueCpf = unMaskCpf(e.target.value.trim())
        setFormLogin(prevState=> ({...prevState, cpf: valueCpf}))
        e.currentTarget.value = maskCpf(e.currentTarget.value.trim())
    }

    const handlePassword = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormLogin(prevState=> ({...prevState, password: e.target.value.trim()}))
    }

    const fieldsProps : {label: iLabel, input: iInput}[] =  [
        {
            label: {htmlFor:"sellerCode", name: "Código Vendedor"},
            input: {className: error.isToShowInput===true ? "errorColor" : "", onChange: handleSellerCode, type: "text", id:"sellerCode", placeholder: "Qual é o seu código?"} 
        },
        {
            label: {htmlFor: "cpf", name: "CPF"},
            input: {className: error.isToShowInput===true ? "errorColor" : "", onChange: handleCpf, type:"text", id: "cpf", placeholder: "Qual é o seu CPF?"} 
        },
        {
            label: {htmlFor:"password", name:"Senha"},
            input: {className: error.isToShowInput===true ? "errorColor" : "",  onChange: handlePassword, type: "password", id: "password", placeholder: "Qual é a senha?"} 
        },
    ]
    
    const buttonProps: iButton = {
        onClick: () => onLoginHandler(formLogin.sellerCode, formLogin.cpf, formLogin.password),
        name: "entrar",
        disabled: 
            formLogin.cpf.length === 11 && 
            formLogin.sellerCode.length >= 1 && 
            formLogin.password.length >= 1? false : true,
    }

    return (
        <S.Container >
            <S.Form>
                <Title className={"title"} />

                {fieldsProps.map(({input, label}) =>(
                    
                    <React.Fragment key={input.id}>
                        <Label {...label}/>
                        <Input {...input}/> 
                    </React.Fragment>
                ))} 
               <small>{error.error} </small>

                <Button {...buttonProps}/>           
            </S.Form> 
        </S.Container>
    )
}

export default Login